"use strict";
var ViewMode;
(function (ViewMode) {
    ViewMode[ViewMode["Symbolic"] = 0] = "Symbolic";
    ViewMode[ViewMode["Absolute"] = 1] = "Absolute";
})(ViewMode = exports.ViewMode || (exports.ViewMode = {}));
